import { useState } from 'react';
import { CellContext, createColumnHelper } from '@tanstack/react-table';
import { FileText } from 'lucide-react';

import { DescribeModal } from '@/react/kubernetes/components/DescribeModal/DescribeModal';

import { Button } from '@@/buttons';
import { Icon } from '@@/Icon';

import { CustomResourceDefinition } from '../../types';

const columnHelper = createColumnHelper<CustomResourceDefinition>();

export const actions = columnHelper.display({
  id: 'actions',
  header: 'Actions',
  cell: Cell,
});

function Cell({ row }: CellContext<CustomResourceDefinition, unknown>) {
  const { name } = row.original;
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Button
        color="link"
        onClick={() => setModalOpen(true)}
        className="!ml-0 pl-0"
        data-cy="custom-resource-definition-describe"
      >
        <Icon icon={FileText} />
        Describe
      </Button>

      {modalOpen && (
        <DescribeModal
          name={name}
          resourceType="customresourcedefinition"
          onDismiss={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
